import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";

/**
  This function is based on the (https://github.com/nency-gajjar/best-way-to-register-common-component) repository

  Register base components globally
*/
export function registerBaseComponentsGlobally() {
  const requireComponent = require.context(
    "@/components/base",
    true,
    /Base[A-Z]\w+\.(vue|js)$/
  );

  requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName = upperFirst(
      camelCase(
        fileName
          .split("/")
          .pop()
          .replace(/\.\w+$/, "")
      )
    );

    // Register component globally
    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}
